import React from "react";

import { ReactComponent as FrydaLogo } from "./../../assets/logo/Fryda_logo.svg";
import { ReactComponent as LoadingAimation } from "./../../assets/svg/loading.svg";

type Props = {
  floating?: boolean;
};

export const Loading = ({ floating }: Props) => {
  if (floating) {
    return (
      <div className="fixed top-0 right-0 left-0 z-50 w-full h-full md:inset-0 justify-center items-center backdrop-blur no-scrollbar flex">
        <div className="text-center">
          <FrydaLogo className="mx-auto" />

          <LoadingAimation className="mx-auto mt-6" />

          <p className="mt-6 text-base leading-7 text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <main className="h-screen bg-white flex justify-center items-center">
      <div className="text-center">
        <FrydaLogo className="mx-auto" />

        <LoadingAimation className="mx-auto mt-6" />

        <p className="mt-6 text-base leading-7 text-gray-400">Loading...</p>
      </div>
    </main>
  );
};

Loading.propTypes = {
  floating: false,
};
